import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.less']
})
export class ProgressComponent implements OnInit {
  @Input() statisticsMap:any = {}; 
  delivered:number=0;
  beProcessed:number=0;
  @Input() cancelled:boolean=false;
  open:number=0;
  total:number=0;
  constructor() { }
  //Display if there is value, do not display if there is no value, the width of the display is calculated
  //Round corners, the outermost edges are rounded on both sides
  ngOnInit(): void {
    if(this.cancelled){
      return;
    }
    this.open = this.statisticsMap["Open"]??0;
    this.delivered = this.statisticsMap["Completed"]??0;
    this.beProcessed = this.statisticsMap["Being Processed"]??0;
    this.total = this.delivered + this.beProcessed + this.open; 
  }

}
